export type LanguageDirection = 'ltr' | 'rtl';

export type LanguageDescriptor = {
  code: string;
  // Name shown to users, in the language itself.
  nativeName: string;
  flag: string;
  dir: LanguageDirection;
};

export const DEFAULT_LANGUAGE = 'en';

// Order here is the order shown in the language switcher.
export const SUPPORTED_LANGUAGES: LanguageDescriptor[] = [
  {
    code: 'en', nativeName: 'English', flag: '🇬🇧', dir: 'ltr',
  },
  {
    code: 'ru', nativeName: 'Русский', flag: '🇷🇺', dir: 'ltr',
  },
  {
    code: 'zh', nativeName: '中文', flag: '🇨🇳', dir: 'ltr',
  },
  {
    code: 'es', nativeName: 'Español', flag: '🇪🇸', dir: 'ltr',
  },
  {
    code: 'fr', nativeName: 'Français', flag: '🇫🇷', dir: 'ltr',
  },
  {
    code: 'de', nativeName: 'Deutsch', flag: '🇩🇪', dir: 'ltr',
  },
  {
    code: 'hi', nativeName: 'हिन्दी', flag: '🇮🇳', dir: 'ltr',
  },
  {
    code: 'ar', nativeName: 'العربية', flag: '🇸🇦', dir: 'rtl',
  },
  {
    code: 'bn', nativeName: 'বাংলা', flag: '🇧🇩', dir: 'ltr',
  },
  {
    code: 'pt', nativeName: 'Português', flag: '🇵🇹', dir: 'ltr',
  },
  {
    code: 'ko', nativeName: '한국어', flag: '🇰🇷', dir: 'ltr',
  },
  {
    code: 'th', nativeName: 'ไทย', flag: '🇹🇭', dir: 'ltr',
  },
  {
    code: 'ja', nativeName: '日本語', flag: '🇯🇵', dir: 'ltr',
  },
  {
    code: 'he', nativeName: 'עברית', flag: '🇮🇱', dir: 'rtl',
  },
];

export const SUPPORTED_LANGUAGE_CODES: string[] = SUPPORTED_LANGUAGES.map((l) => l.code);

export function isSupportedLanguage(code: string): boolean {
  return SUPPORTED_LANGUAGE_CODES.includes(code);
}

export function getLanguageDescriptor(code: string): LanguageDescriptor | undefined {
  return SUPPORTED_LANGUAGES.find((l) => l.code === code);
}
